import { BOToothQuoteDetail } from "./BOToothQuoteDetail.model";

export class BOQuoteDataByTooth{

  patientName:string;
  toothTypeIdString:string;
  incidents:number;
  price:number=0;
  list:BOToothQuoteDetail[]=[];
}
